<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">
<a id="page_ii">
</a><a id="page_iii">Lord Valentine’s Castle</a></h1><a id="page_iii">
<h1 class="title1"> </h1>
<h1 class="title1">The Majipoor Cycle</h1>
<p class="author">Robert Silverberg</p>
<div class="img_containerp"><img alt="image" src="images/logo.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Title.vue?0490f4d5